// @flow
import React, { Component } from 'react';

import Radio from 'common/domain/radio';
import DateRange from 'common/domain/DateRange';

import SalesPrinting from 'common/modules/sales/components/printing/SalesPrinting';
import Estimation from 'common/modules/proposition/domain/estimation';
import PrintingService from 'common/services/PrintingService';
import PrintingPage from 'common/components/PrintingPage';

type State = {
  loaded: boolean;
  estimation: ?Estimation;
  dateRange: ?DateRange;
  radio: ?Radio;
}

class PropositionPrintingPage extends Component<void, State> {
  state = {
    loaded: false,
    estimation: undefined,
    dateRange: undefined,
    radio: undefined,
  };

  componentWillMount() {
    const data = PrintingService.getData('SALES_DATA');
    if (!data) {
      return;
    }

    this.setState({
      loaded: true,
      estimation: Estimation.parse(data.estimation),
      dateRange: DateRange.fromISO(data.dateRange),
      radio: data.radio,
    }, () => {
      setTimeout(() => window.print(), 1000);
    });
  }

  render() {
    const { loaded, radio, estimation, dateRange } = this.state;
    return (
      <PrintingPage loading={!loaded} >
        {radio && estimation &&
          <SalesPrinting
            dateRange={dateRange}
            estimation={estimation}
            radio={radio}
          />
        }
      </PrintingPage>
    );
  }
}

export default PropositionPrintingPage;



// WEBPACK FOOTER //
// ./src/advertisers/modules/propositions/PropositionPrintingPage.js